import React from 'react'
import { format } from 'date-fns'
import ImageContainer from '../image-container/image-container.component'

const TradePortalPostCard = ({
  post,
  gameElements,
  isOwn,
  onClick
}) => {
  const offeringEl = gameElements?.[post.offering?.itemId]

  const pendingOfferCount = Object.values(post.offers ?? {})
    .filter((o) => o.status === 'pending').length

  function getRequestLabel(req) {
    if (req.type === 'currency') return `${req.quantity} Currency`
    if (req.type === 'points') return `${req.quantity} Points`
    const el = gameElements?.[req.itemId]
    const name = el?.name ?? req.itemId
    return req.quantity > 1 ? `${req.quantity}x ${name}` : name
  }

  function formatTs(ts) {
    if (!ts) return ''
    try {
      const d = ts.toDate ? ts.toDate() : new Date(ts)
      return format(d, 'MMM d')
    } catch {
      return ''
    }
  }

  return (
    <div className='trade-post-card' onClick={onClick}>
      <div className='offer-request-container'>
        <div className='meta'>Offering...</div>
        <div className="g-space-0-5"></div>
        <div className='item-card'>
          {offeringEl?.icon && (
            <ImageContainer src={offeringEl.icon} alt={offeringEl.name} />
          )}
          <span className='offering-name'>{offeringEl?.name ?? 'Item'}</span>
          {post.offering?.quantity > 1 && (
            <span className='offering-qty'>x{post.offering.quantity}</span>
          )}
        </div>
      </div>

      <span className='card-arrow'>&#8594;</span>

      <div className='requesting'>
        {post.requesting?.length > 0
          ? 
          <div className='offer-request-container'>
            <div className='meta'>Requesting...</div>
            <div className="g-space-0-5"></div>
            <div className='request-list'>
              {
                post.requesting.map((r, i) => {
                  console.log(r);
                  if (r.type === 'currency') {
                    return (
                      <div key={i} className='item-card'>
                        <ImageContainer src="/images/icons/coin.png" alt={getRequestLabel(r)} />
                        <span className='offering-name'>
                          {getRequestLabel(r)}
                        </span>
                      </div>
                    )
                  }
                  const element = gameElements?.[r.itemId]
                  return (
                    <div key={i} className='item-card'>
                      {element?.icon && (
                        <ImageContainer src={element.icon} alt={element.name} />
                      )}
                      <span className='offering-name'>{getRequestLabel(r)}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
          : <span className='open-offer-text'>Open to offers</span>
        }
      </div>

      <div className='card-meta'>
        <span className='meta-poster'>{post.displayName}</span>
        <span className='meta-date'>{formatTs(post.ts_created)}</span>
        {isOwn && pendingOfferCount > 0 && (
          <span className='meta-offers'>
            {pendingOfferCount} offer{pendingOfferCount !== 1 ? 's' : ''}
          </span>
        )}
        <span className={`post-status ${post.status}`}>
          {post.status?.replace('_', ' ')}
        </span>
      </div>
    </div>
  )
}

export default TradePortalPostCard
